import { Action } from '@ngrx/store';
import { Product } from '../../common/interfaces/product.interface';
import { Order } from '../../common/interfaces/order.interface';
import { OrderDocument } from '../../orders/interfaces/order-document.interface';

export const ActionTypes = {
    UPDATE_ORDER_FORM: '[Order Container] Update',
    UPDATE_DELIVERY_INFO_FORM: '[Delivery info Container] Update',
    UPDATE_PICKUP_INFO_FORM: '[Pickup info Container] Update',
    ADD_DOCUMENT: '[Document Container] Add',
    UPDATE_DOCUMENT: '[Document Container] Update',
    DELETE_DOCUMENT: '[Document Container] Delete',
    ADD_PRODUCT: '[Product Container] Add',
    UPDATE_PRODUCT: '[Product Container] Update',
    UPDATE_QUANTITY_FOR_PRODUCT: '[Products Container] Update quantity',
    DELETE_PRODUCT: '[Product Container] Delete',
    CLEAR_ADD_ORDER: '[Add Order Container] Clear'
};

export class UpdateOrderForm implements Action {
    type = ActionTypes.UPDATE_ORDER_FORM;
    payload: Order;

    public constructor(orderForm: Order) {
        this.payload = orderForm;
    }
}

export class UpdateDeliveryInfoForm implements Action {
    type = ActionTypes.UPDATE_DELIVERY_INFO_FORM;
    payload: any;

    public constructor(deliveryInfoForm: any) {
        this.payload = deliveryInfoForm;
    }
}

export class UpdatePickupInfoForm implements Action {
    type = ActionTypes.UPDATE_PICKUP_INFO_FORM;
    payload: any;

    public constructor(pickupInfoForm: any) {
        this.payload = pickupInfoForm;
    }
}

export class AddDocument implements Action {
    type = ActionTypes.ADD_DOCUMENT;
    payload: OrderDocument;

    public constructor(document: OrderDocument) {
        this.payload = document;
    }
}

export class UpdateDocument implements Action {
    type = ActionTypes.UPDATE_DOCUMENT;
    payload: {
        id: string;
        document: OrderDocument,
    };

    public constructor(id: string, document: OrderDocument) {
        this.payload = {id, document};
    }
}

export class DeleteDocument implements Action {
    type = ActionTypes.DELETE_DOCUMENT;
    payload: string;

    public constructor(id: string) {
        this.payload = id;
    }
}

export class AddProduct implements Action {
    type = ActionTypes.ADD_PRODUCT;
    payload: Product;

    public constructor(product: Product) {
        this.payload = product;
    }
}

export class UpdateProduct implements  Action {
    type = ActionTypes.UPDATE_PRODUCT;
    payload: {
        index: number,
        product: Product
    };

    public constructor(index: number, product: Product) {
        this.payload = {index, product};
    }
}

export class UpdateQuantityForProduct implements  Action {
    type = ActionTypes.UPDATE_QUANTITY_FOR_PRODUCT;
    payload: {
        index: number,
        quantity: number
    };

    public constructor(index: number, quantity: number) {
        this.payload = {index, quantity};
    }
}

export class DeleteProduct implements  Action {
    type = ActionTypes.DELETE_PRODUCT;
    payload: number;

    public constructor(index: number) {
        this.payload = index;
    }
}

export class ClearAddOrder implements Action {
    type = ActionTypes.CLEAR_ADD_ORDER;
}
